import { Injectable, isDevMode } from '@angular/core';
import { CompanyCompanyDaoService } from 'src/app/dao/company-dao-services/company-company-dao-service/company-company-dao.service';
import { Subject, EMPTY } from 'rxjs';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { UserService } from '../../user-service/user.service';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';
import { CompanyInfo } from 'src/app/models/company-data-model/company-info.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyCompanyService {

  accessToken = 'COM';
  refreshCompanyListener = new Subject();

  constructor(private companyDaoService: CompanyCompanyDaoService,
              private userService: UserService,
              private userStorageService: UserStorageService) { }

  public getCompanyInfo() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.companyDaoService.getCompanyInfo(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), this.userStorageService.getCompanyData().CompanyCode).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const companyInfo = new CompanyInfo();
          Object.assign(companyInfo, o['data']['companyDetails']);
          return companyInfo;
        })
      );
    }
    return EMPTY;
  }

  public updateCompany(internalId, city, companyCif, companyName, country, email, faxNumber, fiscalName, phoneNumber, province, region, street, zipCode) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.companyDaoService.updateCompany(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, city, companyCif, companyName, country, email, faxNumber, fiscalName, phoneNumber, province, region, street, zipCode).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateCompanyImage(internalId, imageRaw, size) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.companyDaoService.updateCompanyImage(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, imageRaw, size).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public refreshCompanyListen() {
    return this.refreshCompanyListener.asObservable();
  }

  public refreshCompany() {
    this.refreshCompanyListener.next();
  }
}
